import { QueryResult } from '@eika-infrastruktur/react-query';

import { useAllFuturePayments } from '../../fetchHooks/useFuturePayments';
import type { Account, AccountNumber, PaymentItem, TransactionActor } from '../../generated-types';

const compAccounts = (a?: TransactionActor, b?: AccountNumber) => b && a?.accountNumber?.value === b.value;

const useExtendedFuturepayments = (account?: Account): QueryResult<PaymentItem[]> => {
    return useAllFuturePayments({
        enabled: !!account,
        select: (payments: PaymentItem[]) => {
            return payments
                ?.filter(
                    (payment) =>
                        compAccounts(payment.from, account?.accountNumber) ||
                        compAccounts(payment.receiver, account?.accountNumber),
                )
                .map((payment) => {
                    if (compAccounts(payment.receiver, account?.accountNumber)) {
                        return {
                            ...payment,
                            amount: -payment.amount,
                            estimatedAmount: payment.estimatedAmount ? -payment.estimatedAmount : undefined,
                        };
                    }
                    return payment;
                });
        },
    });
};

export default useExtendedFuturepayments;
